import fitty from 'fitty';
import throttle from 'lodash/throttle';

let largeLines = fitty('.block-heading__line--one-line:not(.is-style-small)', {
	observeMutations: false,
	maxSize: 44.8,
});

let smallLines = fitty('.block-heading__line--one-line.is-style-small', {
	observeMutations: false,
	maxSize: 24,
});

const fitText = () => {
	if (largeLines.length > 0) {
		largeLines.forEach((line) => {
			line.unsubscribe();
		});

		largeLines = fitty(
			'.block-heading__line--one-line:not(.is-style-small)',
			{
				observeMutations: false,
				maxSize: 44.8,
			}
		);
	}

	if (smallLines.length > 0) {
		smallLines.forEach((line) => {
			line.unsubscribe();
		});

		smallLines = fitty('.block-heading__line--one-line.is-style-small', {
			observeMutations: false,
			maxSize: 24,
		});
	}
};

if (largeLines.length > 0 || smallLines.length > 0) {
	fitText();
	window.addEventListener('resize', throttle(fitText, 100));
}
